import fetchWrapper from '../utils/FetchWrapper'
export function getHistory (type, id) {
  return fetchWrapper('curator', `/${type}/${id}/history`)
}
